<template>
  <div class="login-wrap">
    <transition name="slide-fade">
      <div class="ms-login" v-if="isShow">
        <div class="ms-bg">
          <h2 class="ms-title"></h2>
          <img src="../../assets/img/login.png" alt="登录背景图" />
        </div>
        <div class="ms-content">
          <h2 class="login-title">{{ isSmsLogin ? '账号' : '验证码' }}登录</h2>
          <div class="login-divide-line"></div>
          <h4 class="login-tip"></h4>
          
          <!-- 账号密码登录 -->
          <el-form  v-if="isSmsLogin" 
            :model="param" 
            :rules="accountRules" 
            ref="accountForm" 
            label-width="0px"
            @submit.native.prevent="submitForm"
          >
            <el-form-item prop="userName">
              <el-input
                ref="userNameInput"
                prefix-icon="el-icon-user"
                v-model="param.userName"
                placeholder="请输入登录账号"
                @keyup.enter.native="submitForm"
              />
            </el-form-item>
            
            <el-form-item prop="password">
              <el-input
                prefix-icon="el-icon-lock"
                type="password"
                placeholder="请输入登录密码"
                v-model="param.password"
                autocomplete="new-password"
                show-password
                @keyup.enter.native="submitForm"
              />
            </el-form-item>
            
            <div class="login-btn">
              <el-button 
                type="primary" 
                :loading="loading" 
                @click="submitForm"
                style="width: 100%"
              >
                {{ loading ? '登录中...' : '登录' }}
              </el-button>
            </div>
          </el-form>
          
          <!-- 短信验证码登录 -->
          <el-form  v-else 
            :model="smsParam" 
            :rules="smsRules" 
            ref="smsForm" 
            label-width="0px"
            autocomplete="off"
            @submit.native.prevent="submitSmsForm"
          >
            <!-- 隐藏输入框防止自动填充 -->
            <input type="text" style="display:none" tabindex="-1">
            <input type="password" style="display:none" tabindex="-1">
            
            <el-form-item prop="mobile">
              <el-input
                ref="mobileInput"
                prefix-icon="el-icon-mobile"
                v-model="smsParam.mobile"
                placeholder="请输入手机号"
                autocomplete="off"
                name="mobile"
                maxlength="11"
                @keyup.enter.native="submitSmsForm"
              />
            </el-form-item>
            
            <el-form-item prop="code">
              <div class="sms-code-wrapper">
                <el-input
                  prefix-icon="el-icon-lock"
                  placeholder="请输入短信验证码"
                  v-model="smsParam.code"
                  autocomplete="off"
                  name="smsCode"
                  maxlength="6"
                  @keyup.enter.native="submitSmsForm"
                />
                <el-button 
                  :disabled="smsCodeDisabled" 
                  @click="getSmsCode"
                  :loading="codeLoading"
                  size="small"
                  class="sms-code-btn"
                >
                  {{ codeButtonText }}
                </el-button>
              </div>
            </el-form-item>
            
            <div class="login-btn">
              <el-button 
                type="primary" 
                :loading="loading" 
                @click="submitSmsForm"
                style="width: 100%"
              >
                {{ loading ? '登录中...' : '登录' }}
              </el-button>
            </div>
          </el-form>
          
          <div class="switch-login-type" @click="toggleLoginType">
            {{ isSmsLogin ? '短信验证码登录' : '账号密码登录' }}
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { setStorage } from '@/utils/index.js';
import { login, sendSmsCode, smsLogin } from '@/api/user.js';
import axios from 'axios';
export default {
  name: 'Login',
  data() {
    // 短信验证码校验规则
    const validateMobile = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'));
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    };
    
    const validateCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入短信验证码'));
      } else if (!/^\d{6}$/.test(value)) {
        callback(new Error('验证码为6位数字'));
      } else {
        callback();
      }
    };
    
    return {
      isShow: false,
      isSmsLogin: true,
      loading: false,
      codeLoading: false,
      // 倒计时相关
      countdown: 60,
      timer: null,
      
      // 账号密码登录表单
      param: {
        userName: '',
        password: ''
      },
      
      // 短信登录表单
      smsParam: {
        mobile: '',
        code: ''
      },
      
      // 账号密码登录校验规则
      accountRules: {
        userName: [
          { required: true, message: '请输入登录账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入登录密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少6位', trigger: 'blur' }
        ]
      },
      
      // 短信登录校验规则
      smsRules: {
        mobile: [
          { required: true, validator: validateMobile, trigger: 'blur' }
        ],
        code: [
          { required: true, validator: validateCode, trigger: 'blur' }
        ]
      }
    };
  },
  
  computed: {
    smsCodeDisabled() {
      const isMobileInvalid = !this.smsParam.mobile || !/^1[3-9]\d{9}$/.test(this.smsParam.mobile);
      const isCountdownActive = this.countdown > 0;
      return isMobileInvalid || isCountdownActive;
    },
    
     codeButtonText() {
      return this.countdown > 0 ? `${this.countdown}秒后重发` : '获取验证码';
     }
  },
  
  mounted() {
    this.isShow = true;
   
  },
  
  beforeDestroy() {
    // 清除定时器
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  
  methods: {
    // 切换登录方式
    toggleLoginType() {
      this.isSmsLogin = !this.isSmsLogin;
      if (this.isSmsLogin) {
        this.smsParam = { mobile: '', code: '' };
         if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
        this.countdown = 0; 
      } else{
         this.countdown = 0; 
      }
      
    },
    
    // 账号密码登录
    submitForm() {
      this.$refs.accountForm.validate((valid) => {
        if (valid) {
          this.handleLogin(this.param, 'account');
        }
      });
    },
    
    // 短信验证码登录
    submitSmsForm() {
      this.$refs.smsForm.validate((valid) => {
        if (valid) {
          this.handleLogin(this.smsParam, 'sms');
        }
      });
    },
    
    //登录处理
    async handleLogin(loginData, type) {
      if (this.loading) return;
      
      this.loading = true;
      
      try {
        
        if (type === 'account') {
           var res = await login(loginData);
             if (res.success) {
                this.$message.success('登录成功');
                setStorage('token', res.token);
                setStorage('refreshToken', res.refreshToken);
                this.$router.push('/');
                } else {
                this.$message.error(res.msg || '登录失败');
                }
        } else {
            var res = await smsLogin({phone: this.smsParam.mobile,code: this.smsParam.code});
             if (res.code === 200) {
                this.$message.success(res.msg);
                setStorage('token', res.token);
                setStorage('refreshToken', res.refreshToken);
                this.$router.push('/');
                } else {
                this.$message.error(res.msg || '登录失败');
                }          
        }
        
      
      } catch (error) {
        this.$message.error('登录请求失败，请稍后重试');
      } finally {
        this.loading = false;
      }
    },
    
    // 获取短信验证码
    async getSmsCode() {
      if (this.codeLoading) return;
      if (!this.smsParam.mobile) {
        this.$message.warning('请输入手机号');
        return;
      }
      
      if (!/^1[3-9]\d{9}$/.test(this.smsParam.mobile)) {
        this.$message.warning('请输入正确的手机号');
        return;
      }
      
      this.codeLoading = true;
      try {
           const res = await sendSmsCode({phone: this.smsParam.mobile})  
           if (res.code === 200) {
                     this.$message.success(res.msg);
                     this.startCountdown();
                } else {
                    this.$message.error(res.msg || '发送失败');
                }
      } catch (error) {
        this.$message.error('验证码发送失败，请稍后重试');
        console.error('发送验证码错误:', error);
      } finally {
        this.codeLoading = false;
      }
    },
    
    // 开始倒计时
    startCountdown() {
        this.countdown = 60;
        this.timer = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) {
              clearInterval(this.timer);
              this.timer = null;
            }
        }, 1000);
        },
  }
};
</script>

<style scoped>
.slide-fade-enter-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-1999px);
}

.slide-fade-enter-to {
  transform: translateY(0);
}

.login-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url('../../assets/img/login-background.png') no-repeat;
  background-size: 100% 100%;
}

.ms-login {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80%;
  max-width: 1400px;
  height: 60%;
}

.ms-bg {
  position: relative;
  width: 594px;
  height: 585px;
  border-radius: 20px;
  margin-right: 100px;
}

.ms-bg img {
  width: 100%;
  height: 100%;
  border-radius: 4px;
}

.ms-title {
  position: absolute;
  top: 10%;
  left: 10%;
  line-height: 50px;
  font-size: 30px;
  color: #fff;
}

.ms-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 350px;
  height: 500px;
  padding: 30px;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.login-title {
  margin: 5% 0 20px;
  font-size: 32px;
  font-weight: 500;
  color: #4b62ea;
  text-align: center;
}

.login-divide-line {
  border-bottom: 1px solid #ddd;
  margin-bottom: 30px;
}

.login-tip {
  font-size: 18px;
  color: #b0aabf;
}

.sms-code-wrapper {
  display: flex;
}

.sms-code-wrapper .el-input {
  flex: 1;
}

/* .sms-code-btn {
  width: 120px;
  height: 40px;
} */

.login-btn {
  margin-top: 30px;
  margin-bottom: 20%;
  text-align: center;
}

.login-btn .el-button {
  margin-top: 20px;
  height: 50px;
  font-size: 20px;
}

.switch-login-type {
  text-align: center;
  color: #409eff;
  cursor: pointer;
  font-size: 14px;
  margin-top: 20px;
}

.switch-login-type:hover {
  color: #66b1ff;
}

/* 输入框样式优化 */
::v-deep .el-input__inner {
  height: 50px;
  font-size: 16px;
}

::v-deep .el-input__icon {
  font-size: 18px;
}
</style>